import EditorProvider from './EditorContext';
import Editor from './Editor';
import { IRegistration } from '../../RegistrationContext';


interface IProps {
    registration: IRegistration
}

let Index = (props: IProps) => {
    return (
        <EditorProvider {...props}>
            <Editor />
        </EditorProvider>
    )
}

export default Index;